import { memo } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import { Message } from '@/lib/types';

interface Props {
  message: Message;
  isOwn: boolean;
}

/**
 * Bolha individual de mensagem no chat.
 *
 * Memoizada porque cada conversa pode ter dezenas/centenas de mensagens
 * e nova mensagem nao deve re-renderizar todas as anteriores.
 *
 * Comparacao customizada: re-renderiza so se message.id, content,
 * photo_url ou isOwn mudarem. Outros campos (timestamps de cache) sao
 * ignorados.
 */
function MessageBubbleComponent({ message, isOwn }: Props) {
  return (
    <View style={[styles.messageRow, isOwn ? styles.messageRowRight : styles.messageRowLeft]}>
      <View style={[styles.bubble, isOwn ? styles.bubbleOwn : styles.bubbleOther]}>
        {message.photo_url ? (
          <Image source={{ uri: message.photo_url }} style={styles.photoMessage} resizeMode="cover" />
        ) : (
          <Text style={[styles.messageText, isOwn ? styles.messageTextOwn : styles.messageTextOther]}>
            {message.content}
          </Text>
        )}
        <Text style={[styles.messageTime, isOwn ? styles.messageTimeOwn : styles.messageTimeOther]}>
          {new Date(message.created_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
        </Text>
      </View>
    </View>
  );
}

export const MessageBubble = memo(
  MessageBubbleComponent,
  (prev, next) =>
    prev.message.id === next.message.id &&
    prev.message.content === next.message.content &&
    prev.message.photo_url === next.message.photo_url &&
    prev.isOwn === next.isOwn,
);

const styles = StyleSheet.create({
  messageRow: { marginBottom: 8 },
  messageRowRight: { alignItems: 'flex-end' },
  messageRowLeft: { alignItems: 'flex-start' },
  bubble: { maxWidth: '78%', borderRadius: 16, padding: 10 },
  bubbleOwn: { backgroundColor: '#FFF0F2', borderBottomRightRadius: 4 },
  bubbleOther: { backgroundColor: '#fff', borderBottomLeftRadius: 4 },
  messageText: { fontSize: 15, lineHeight: 20 },
  messageTextOwn: { color: '#1A1A1A' },
  messageTextOther: { color: '#1A1A1A' },
  messageTime: { fontSize: 10, marginTop: 4 },
  messageTimeOwn: { color: '#C8102E', textAlign: 'right' },
  messageTimeOther: { color: '#aaa' },
  photoMessage: { width: 200, height: 200, borderRadius: 8 },
});
